import React from 'react';

import {Grid} from '@mui/material';
import {useParams} from 'react-router-dom';

import {Head} from '@wheeebo/polaris-ui';

import SettingsCard from '@components/pages/vehicle/SettingsCard';
import VehicleUpdateCard from '@components/pages/vehicle/VehicleUpdateCard';

function VehiclePage(): JSX.Element {
  const params = useParams();
  return (
    <Grid container spacing={1}>
      <Head title="Vehicle" />
      <Grid item xs={12} sm={8}>
        {params.vehicleId ? <VehicleUpdateCard vehicleId={params.vehicleId} /> : null}
      </Grid>
      <Grid item xs={12} sm={4}>
        {params.vehicleId ? <SettingsCard vehicleId={params.vehicleId} /> : null}
      </Grid>
    </Grid>
  );
}

export default React.memo(VehiclePage);
